import { jsx as o, jsxs as s, Fragment as b } from "react/jsx-runtime";
import S from "react";
import k from "@mui/material/SnackbarContent";
import e, { useTheme as T } from "styled-components";
import w from "../../../icons/close.js";
import { sizes as v } from "../../../theme/utils/styleUtils.js";
import N from "../../IconButton/IconButton.js";
import { getVariantColor as R, getIcon as W } from "../utils/utils.js";
const I = {
  root: "snackbarContentRoot",
  message: "snackbarContentMessage",
  action: "snackbarContentAction"
}, B = e.div.withConfig({
  displayName: "PrimaryWrapper"
})([
  "display:flex;flex-direction:row;align-items:center;"
]), z = e.div.withConfig({
  displayName: "IconWrapper"
})([
  "width:16px;height:16px;display:flex;align-items:center;justify-content:center;margin-right:16px;"
]), P = e.span.withConfig({
  displayName: "PrimaryText"
})([
  "color:",
  ";font-weight:",
  ";line-height:1.2em;"
], ({ theme: t, $variant: r = "info", $hasTitle: i }) => i ? R(t, r) : "inherit", ({ theme: t, $hasTitle: r }) => r ? t.typography.fontWeightBold : t.typography.fontWeightRegular), j = e.div.withConfig({
  displayName: "SecondaryWrapper"
})([
  "display:flex;flex-direction:column;margin:12px 0px 0px 0px;"
]), M = e.span.withConfig({
  displayName: "SecondaryText"
})([
  "line-height:1.2em;"
]), $ = e.span.withConfig({
  displayName: "TertiaryText"
})([
  "color:",
  ";line-height:1.2em;margin-top:",
  ";"
], ({ theme: t }) => t.text.secondary, ({ $hasSecondaryText: t }) => t ? "4px" : "0px"), A = e(N).withConfig({
  displayName: "StyledIconButton"
})([
  "&&.iconButtonRoot{height:20px;width:20px;margin-right:-2px;}"
]), _ = e(k).withConfig({
  displayName: "StyledSnackbarContent"
})([
  "&&.snackbarContentRoot{min-height:34px;color:",
  ";font-size:",
  ";background-color:",
  ";box-sizing:border-box;border:none;padding:8px 12px;}&&.snackbarContentRoot .snackbarContentMessage{display:flex;flex-direction:column;padding:0px;flex:1;}&&.snackbarContentRoot .snackbarContentAction{margin:0px 0px 0px 16px;padding:0px;align-self:baseline;}"
], ({ theme: t }) => t.colors.white, ({ theme: t }) => t.typography.body200.fontSize, ({ theme: t }) => t.isLightTheme ? t.text.primary : t.colors.darkBlue600), K = /* @__PURE__ */ S.forwardRef(({ action: t, classes: r, info: i, message: l, onClose: p, showClose: m = !0, showIcon: g = !0, title: a, variant: d = "info", ...h }, f) => {
  const x = t !== void 0 ? [
    t
  ] : [], y = T();
  m && x.push(/* @__PURE__ */ o(A, {
    onClick: (n, C) => {
      p && p(n, C);
    },
    size: v.extraSmall,
    flavor: y.colors.white,
    variant: "normal",
    "aria-label": "close",
    children: /* @__PURE__ */ o(w, {})
  }, "close"));
  const u = () => {
    if (a === null)
      return "";
    let n = "";
    return a !== void 0 ? n = a : n = l, n;
  }, c = (() => {
    let n;
    return a !== void 0 ? l : n;
  })();
  return /* @__PURE__ */ o(_, {
    ...h,
    ref: f,
    classes: {
      ...I,
      ...r
    },
    message: /* @__PURE__ */ s(b, {
      children: [
        /* @__PURE__ */ s(B, {
          children: [
            g ? /* @__PURE__ */ o(z, {
              children: W(d)
            }) : null,
            /* @__PURE__ */ o(P, {
              $hasTitle: a !== void 0,
              $variant: d,
              children: u()
            })
          ]
        }),
        c || i ? /* @__PURE__ */ s(j, {
          children: [
            c ? /* @__PURE__ */ o(M, {
              children: c
            }) : null,
            i ? /* @__PURE__ */ o($, {
              $hasSecondaryText: c !== void 0,
              children: i
            }) : null
          ]
        }) : null
      ]
    }),
    action: x
  });
});
export {
  K as default
};
